import { useMemo } from 'react';
import { useGetEventByIdQuery, useGetEventsQuery, useGetEventRecordingQuery } from '../../../__generated__/chirp/com/hubspot/academy/learning/events/rpc/LearningEventUserRpc.hooks';
import { GET_EVENT_BY_ID_QUERY, GET_EVENTS_QUERY } from '../../../__generated__/chirp/com/hubspot/academy/learning/events/rpc/LearningEventUserRpc.dfc.new';
import { useRegisterUserToEventSessionMutation } from '../../../__generated__/chirp/com/hubspot/academy/learning/events/rpc/EventRegistrationRpc.hooks';
import { useGetProfessorsQuery } from '../../../__generated__/chirp/com/hubspot/academy/learning/events/rpc/ProfessorRpc.hooks';
export const useLearningEvent = eventId => {
  var _data$sessions;
  const {
    data,
    loading,
    error
  } = useGetEventByIdQuery({
    variables: {
      eventId
    },
    skip: !eventId
  });
  const sessions = ((_data$sessions = data === null || data === void 0 ? void 0 : data.sessions) !== null && _data$sessions !== void 0 ? _data$sessions : []).filter(s => !s.deletedAt && s.startTimeMs !== undefined);
  return {
    learningEvent: data,
    sessions,
    loading,
    error
  };
};
export const useEventRecording = eventId => {
  var _data$recordingUrls, _data$attended;
  const {
    data,
    loading,
    error
  } = useGetEventRecordingQuery({
    variables: {
      eventId
    },
    skip: !eventId
  });
  return {
    recordingUrls: (_data$recordingUrls = data === null || data === void 0 ? void 0 : data.recordingUrls) !== null && _data$recordingUrls !== void 0 ? _data$recordingUrls : [],
    attended: (_data$attended = data === null || data === void 0 ? void 0 : data.attended) !== null && _data$attended !== void 0 ? _data$attended : false,
    loading,
    error
  };
};
export const useLearningEvents = (variables = {}, {
  skip
} = {}) => {
  var _data$results, _data$hasMore;
  const {
    data,
    loading,
    error,
    refetch
  } = useGetEventsQuery({
    variables,
    skip
  });
  return {
    learningEvents: (_data$results = data === null || data === void 0 ? void 0 : data.results) !== null && _data$results !== void 0 ? _data$results : [],
    learningEventsHasMore: (_data$hasMore = data === null || data === void 0 ? void 0 : data.hasMore) !== null && _data$hasMore !== void 0 ? _data$hasMore : false,
    learningEventsNextOffset: data === null || data === void 0 ? void 0 : data.offset,
    learningEventsLoading: loading,
    learningEventsError: error,
    refetchLearningEvents: refetch
  };
};
export const useEventInstructors = professorIds => {
  const {
    data,
    loading,
    error
  } = useGetProfessorsQuery({
    variables: {
      professorIds
    },
    skip: professorIds.length === 0
  });
  const idsKey = professorIds.join(',');
  const professors = useMemo(() => {
    var _data$professors;
    const professorsById = (_data$professors = data === null || data === void 0 ? void 0 : data.professors) !== null && _data$professors !== void 0 ? _data$professors : {};
    return professorIds.map(id => professorsById[String(id)]).filter(p => p !== undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, idsKey]);
  return {
    professors,
    loading,
    error
  };
};
export const useRegisterForSession = ({
  eventId,
  onCompleted,
  onError,
  onFallback
}) => {
  const [mutate, {
    loading,
    error
  }] = useRegisterUserToEventSessionMutation({
    onCompleted: wrapped => {
      if (wrapped.result.registrationSucceeded === true) {
        onCompleted === null || onCompleted === void 0 || onCompleted(wrapped.result);
      } else {
        onFallback === null || onFallback === void 0 || onFallback(wrapped.result.registrationUrl);
      }
    },
    onError,
    refetchQueries: [{
      query: GET_EVENT_BY_ID_QUERY,
      variables: {
        eventId
      }
    }, GET_EVENTS_QUERY],
    awaitRefetchQueries: true
  });
  return {
    registerForSession: eventSessionExternalId => mutate({
      variables: {
        eventSessionExternalId
      }
    }),
    registrationLoading: loading,
    registrationError: error
  };
};